import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/ImageV2';
import { Small, MediumUp } from 'components/MediaQuery';
import { IMAGE_RATIOS, IMAGE_WIDTHS } from 'constants/images';

const ArticlePagePromoHeroBackgroundImage = ({ image }) => {
  const landscapeImage = get(image, 'landscape');
  const portraitImage = get(image, 'portrait');

  return (
    <>
      <Small>
        <Image
          className="ArticlePagePromoHero__image"
          src={get(portraitImage, 'src')}
          alt={get(portraitImage, 'alt', '')}
          width={IMAGE_WIDTHS.W_1200}
          ratio={IMAGE_RATIOS.R_5x6}
        />
      </Small>
      <MediumUp>
        <Image
          className="ArticlePagePromoHero__image"
          src={get(landscapeImage, 'src')}
          alt={get(landscapeImage, 'alt', '')}
          width={IMAGE_WIDTHS.W_2000}
          ratio={IMAGE_RATIOS.R_16x9}
        />
      </MediumUp>

      <style jsx global>
        {`
          .ArticlePagePromoHero__image {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        `}
      </style>
    </>
  );
};

const assetPropType = PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string });

ArticlePagePromoHeroBackgroundImage.propTypes = {
  image: PropTypes.shape({
    landscape: assetPropType.isRequired,
    portrait: assetPropType.isRequired,
  }).isRequired,
};

export default ArticlePagePromoHeroBackgroundImage;
